import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

// Custom layout
import MainLayout from "../../../../Layouts/Main";

// styles
import "./styles.scss";

// assets
import assets from "../../../../Assets";

//slice
import { fetchIndividualProductTraining } from "../../../../Redux/Slices/contentManagementSlice";

const ViewProductTraining = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [productTrainingData, setProductTrainingData] = useState(null);
    const LEARNING_TYPE = {
      1: "Reading and Writing",
      2: "Visual",
      3: "Auditory",
      4: "Kinesthetic",
    };

    useEffect(() => {
        dispatch(
          fetchIndividualProductTraining({
            data: {
              id: id
            },
            callBack: fetchProductTrainingCB,
          })
        );
    }, [id]);

    const fetchProductTrainingCB = (data) => {
        console.log(data.result);
        setProductTrainingData(data.result);
    };

    return (
      <MainLayout pageName={"Content Management"}>
        <div className="goBackDiv" onClick={() => navigate(-1)}>
          <img src={assets.Icons.leftArrow} alt="backIcon" />
          <p>Back to Product Training List</p>
        </div>
        <div className="product-training-profile-details">
          <div className="view-product-training-container-header">
            <h2>Product Training Details</h2>
          </div>

          <hr style={{ backgroundColor: "#E6E6E6" }} />

          <div className="product-training-details-container">
            {productTrainingData ? (
              <>
                <div style={{ fontWeight: "600", marginBottom: "25px" }}>
                  Training Details
                </div>
                <div className="product-training-details-item">
                  <div className="objKey">Learning Program Title</div>
                  <div>
                    : {productTrainingData.learning_title ?? "Not Captured"}
                  </div>
                </div>
                <div className="product-training-details-item">
                  <div className="objKey">Description</div>
                  <div>
                    : {productTrainingData.description ?? "-"}
                  </div>
                </div>
                <div className="product-training-details-item">
                  <div className="objKey">Category</div>
                  <div>
                    :{" "}
                    {productTrainingData.product_category_name ??
                      "Not Captured"}
                  </div>
                </div>
                <div className="product-training-details-item">
                  <div className="objKey">Sub Category</div>
                  <div>
                    : {productTrainingData?.sub_category?.trim() ? productTrainingData.sub_category : "-"}
                  </div>
                </div>
                <div className="product-training-details-item">
                  <div className="objKey">Learning Type</div>
                  <div>
                    :{" "}
                    {LEARNING_TYPE[productTrainingData.learning_type] ??
                      "Not Captured"}
                  </div>
                </div>
                {/* <div className="product-training-details-item">
                                <div className="objKey">File Type</div>
                                <div>: {productTrainingData.file_type ?? "Not Captured"}</div>
                            </div> */}
                <div className="product-training-details-item">
                  <div className="objKey">File</div>
                  <div>
                    :{" "}
                    {productTrainingData?.file_url ? (
                      <a href={productTrainingData.file_url}>
                        {productTrainingData.file_url.split("---").pop()}
                      </a>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
                <div className="product-training-details-item">
                  <div className="objKey">File Link</div>
                  <div>
                    :
                    {productTrainingData?.content_link ? (
                      <a
                        href={
                          productTrainingData.content_link.startsWith("http")
                            ? productTrainingData.content_link
                            : `https://${productTrainingData.content_link}`
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {productTrainingData.content_link}
                      </a>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        </div>
      </MainLayout>
    );
};

export default ViewProductTraining;
